import { render, staticRenderFns } from "./PwaBlobSmallScreen.vue?vue&type=template&id=651054cd&scoped=true&"
import script from "./PwaBlobSmallScreen.vue?vue&type=script&lang=js&"
export * from "./PwaBlobSmallScreen.vue?vue&type=script&lang=js&"
import style0 from "./PwaBlobSmallScreen.vue?vue&type=style&index=0&id=651054cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651054cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
